<template>
  <div class="message">
    <div class="slide">
      <mySlide />
    </div>
    <div class="mobilew1500">
      <div class="message-main">
        <div class="title flex flex-ac flex-jsb">
          <div class="t">系统通知</div>
          <div class="btns flex flex-ac">
            <div class="btn" @click="handleRead">全部已读</div>
            <div class="btn btn-danger"  @click="handleDel">全部删除</div>
          </div>
        </div>
        <div class="message-list">
          <div>
            <div class="li-box">
              <div v-for="item in list" :key="item.id" class="li">
                <div class="li-title flex flex-jsb">
                  <div class="t flex-1">{{ item.title }} <span v-if="item.read==0" class="point"></span> </div>
                  <div class="time flex-0">{{ item.create_time }}</div>
                </div>
                <div class="content">
                  <div v-html="item.content"></div>
                </div>
              </div>
            </div>
            <div class="csgo-page">
              <el-pagination background layout="prev, pager, next" :current-page.sync="searchForm.page" :total="searchForm.totalSize" :page-size="searchForm.limit" @current-change="currentChange">
              </el-pagination>
            </div>
          </div>
          <empty v-if="list.length===0" :padding="30" description="暂无消息"></empty>
        </div>
      </div>
    </div>
    <div class="commonBg"></div>
    <RulePopup ref="RulePopup" />
  </div>
</template>

<script>
import empty from "@/g-components/empty.vue";
import RulePopup from "@/components/rule-popup.vue"
import mySlide from "@/g-components/my_slide.vue";

export default {
  components: { RulePopup, empty, mySlide },
  data() {
    return {
      searchForm: {
        page: 1,
        totalSize: 0,
        limit: 20,
        status: 1
      },
      list: [],
    };
  },
  created() {
    this.getList()
  },
  methods: {
    handleRead() {
      this.$doPost("/api/member.Message/setRead", {
        ids: 'ALL'
      }).then((res) => {
        this.getList()
      }).catch(() => { })
    },
    handleDel(){
      this.$doPost("/api/member.Message/del", {
        ids: this.list.map(v=>v.id)
      }).then((res) => {
        this.searchForm.page = 1
        this.getList()
      }).catch(() => { })
    },
    handleLookClick(item) {
      this.$refs['RulePopup'].toggleContent(item.title, item.content)
      // this.$router.push({
      //   path: '/InformDetail?id=' + item.id
      // })
    },
    getList() {
      this.$doGet("/api/member.Message/list", this.searchForm).then((res) => {
        this.searchForm.totalSize = res.data.count
        this.list = res.data.list
      }).catch(() => { })
    },
    //分页 所有记录
    currentChange(value) {
      this.searchForm.page = value
      this.getList();
    },
  }
};
</script>

<style lang="less" scoped>
.message {
  padding: 0px 0 30px;
  .message-main {
    background: #1b1c20;
    margin-top: 15px;
    .title {
      height: 60px;
      font-size: 16px;
      color: #ffffff;
      border-bottom: 1px solid #404355;
      padding: 0 36px;
      .btns {
        .btn {
          cursor: pointer;
          width: 110px;
          text-align: center;
          line-height: 30px;
          border-radius: 4px;
          font-size: 14px;
          background: #346162;
          border: 1px solid #00f7ff;
          color: #00f7ff;
          &.btn-danger {
            border: 1px solid #ff6060;
            color: #ff6060;
            background: #6d3939;
            margin-left: 16px;
          }
        }
      }
    }
    .message-list {
      .li-box {
        padding: 0 36px;
        .li {
          padding: 10px 0;
          border-bottom: 1px solid #404355;
          color: #ffffff;
          box-sizing: border-box;
          .li-title {
            line-height: 26px;
            margin-bottom: 12px;
            .point {
              width: 6px;
              height: 6px;
              display: inline-block;
              background: red;
              border-radius: 50%;
              position: relative;
              top: -10px;
            }
            .t {
              font-weight: bold;
              font-size: 18px;
            }
            .time {
              font-size: 14px;
            }
          }
          .content {
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>
